import { Component,input, output } from '@angular/core';

import { VbNestedMenuComponent } from '../shared/VbNestedMenuComponent';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';

@Component({
	selector: 'select-menu',
	templateUrl: './SelectMenu.Component.html',
	standalone: true,
	host: {
		class: 'submenuWrap'
	},
	imports: [
		BsDropdownModule
	],
	styleUrls: ['../VbPlayerSettingsMenu.Component.ng.less', '../MenuButton.ng.less']
})
export class SelectMenuComponent extends VbNestedMenuComponent {
	public readonly options = input.required<{name: string; value: unknown}>();
	public readonly selectedValue = input.required<unknown>();
	public readonly defaultValue = input.required<unknown>();
	public readonly title = input.required<string>();
	public readonly valueSelected = output<unknown>();

	public selectValue(value: unknown): void {
		this.valueSelected.emit(value);
		this.hideMenu();
	}

	public selectDefaultValue(): void {
		this.selectValue(this.defaultValue());
	}
}
